import { delay } from "redux-saga";
import { call, put, fork, take, cancel } from "redux-saga/effects";

export function fetchFactory(
  { setLoading, setFailure, setSuccess, setUi },
  fn
) {
  return function*({ payload }) {
    try {
      if (setLoading) yield put(setLoading(true));
      if (setFailure) yield put(setFailure(""));
      const data = yield call(fn, payload);
      if (setLoading) yield put(setLoading(false));
      if (setSuccess) yield put(setSuccess(data));
      if (setUi) yield put(setUi(data));
    } catch (e) {
      if (setLoading) yield put(setLoading(false));
      if (setFailure) yield put(setFailure(e.message));
    }
  };
}

export const takeOnlyLeading = (pattern, saga, ...args) =>
  fork(function*() {
    const action = yield take(pattern);
    yield call(saga, ...args.concat(action));
  });

export function* debounceFor(pattern, saga, ms, ...args) {
  function* delayedSaga(action) {
    yield call(delay, ms);
    yield call(saga, action, ...args);
  }

  let task;
  while (true) {
    const action = yield take(pattern);
    if (task) yield cancel(task);
    task = yield fork(delayedSaga, action);
  }
}



// WEBPACK FOOTER //
// ./src/store/saga.js